import Vue from 'vue'
import './http'
import App from './App.vue'
import router from './router'
import store from './store/'
import i18n from './i18n'
import VueSnackbar from 'vue-snack'

import utils, { yarnCountUtils, yarnUtils } from './utils'
import settings from './settings'
import storage from './storage'

import DefaultLayout from './layouts/Default.vue'
import FullscreenLayout from './layouts/Fullscreen.vue'
import Vue2TouchEvents from 'vue2-touch-events'
import NProgress from 'nprogress'
// eslint-disable-next-line
import NprogressContainer from 'vue-nprogress/src/NprogressContainer' // Perchè sennò non viene visualizzato

Vue.component('default-layout', DefaultLayout);
Vue.component('fullscreen-layout', FullscreenLayout);

Vue.config.productionTip = false

Vue.use(VueSnackbar, {
	position: 'bottom-right'
});

Vue.use(Vue2TouchEvents);
Vue.use(NProgress);
NProgress.configure({
	// showSpinner: false,
	// parent: '#app-wrapper', // questo causa errori quando ancora non esiste il componente
});

const plugin = {
	install () {
		Vue.utils = utils
		Vue.prototype.$utils = utils

		Vue.yarnCountUtils = yarnCountUtils
		Vue.prototype.$yarnCountUtils = yarnCountUtils

		Vue.yarnUtils = yarnUtils
		Vue.prototype.$yarnUtils = yarnUtils

		Vue.settings = settings
		Vue.prototype.$settings = settings

		Vue.storage = storage
		Vue.prototype.$storage = storage
	}
}
Vue.use(plugin)

const init = () => {
	storage.getItem('customer-token')
	.then((token) => {
		return utils.autoLogin(token);
	})
	.then(() => {
		// eslint-disable-next-line
		console.log('Auto login ok');
	})
	// eslint-disable-next-line
	.catch((err) => {
		// console.log(err);
	})
	.finally(() => {
		store.dispatch('updateYarnsArchive');
		startVue();
	});
	utils.loadSettings();
};

const startVue = () => {
	new Vue({
		router,
		i18n,
		store,
		render: h => h(App)
	}).$mount('#app');
}

// Wait for the deviceready event to start the render
document.addEventListener('deviceready', () => {
	init();
});

function ready(fn) {
	if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}

ready(function() {
	// if (window.isCordovaApp) {
		window.addEventListener('keydown', function(e) {
			if (window.isCordovaApp) window.open = window.cordova.InAppBrowser.open;
			if (e.keyIdentifier == 'U+000A' || e.keyIdentifier == 'Enter' || e.keyCode == 13) {
				if (e.target.nodeName === 'INPUT' && e.target.type !== 'textarea') {
					e.preventDefault();
					// eslint-disable-next-line
					focusNextElement();
					return false;
				}
			}
		}, true);
	// }
});

// If we are not in Cordova, manually trigger the deviceready event
window.isCordovaApp = (typeof window.cordova !== 'undefined');
if (!window.isCordovaApp) {
	document.dispatchEvent(new CustomEvent("deviceready", {}));
}